import React, { FC } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Status } from '@/declarations/models/Status';

const FILTERABLE_STATUSES: ReadonlyArray<Status> = [Status.PUBLISHED, Status.DRAFT, Status.ARCHIVED];

export interface StatusFilterCheckboxesProps {
  selected: Array<Status>;
  onChange: (selected: Array<Status>) => void;
}

/** The ordinary status filter of the page tree: published / draft / archived, OR-combined. */
export const StatusFilterCheckboxes: FC<StatusFilterCheckboxesProps> = ({ selected, onChange }) => {
  const { t: tCommon } = useTranslation('common');

  const toggle = (status: Status, checked: boolean) =>
    onChange(checked ? [...selected, status] : selected.filter((s) => s !== status));

  return (
    <>
      {FILTERABLE_STATUSES.map((status) => (
        <FormControlLabel
          key={status}
          control={
            <Checkbox
              disableRipple
              checked={selected.includes(status)}
              onChange={(_event, checked) => toggle(status, checked)}
            />
          }
          label={tCommon(`Status.${status}`)}
          labelPlacement='end'
        />
      ))}
    </>
  );
};

export default StatusFilterCheckboxes;
